module.exports = __webpack_public_path__ + "img/tabbed-vehicle-rows-kia.b94547aa.png";